import { render, staticRenderFns } from "./DongLingHomePage.vue?vue&type=template&id=4076c184&scoped=true"
import script from "./DongLingHomePage.vue?vue&type=script&lang=js"
export * from "./DongLingHomePage.vue?vue&type=script&lang=js"
import style0 from "./DongLingHomePage.vue?vue&type=style&index=0&id=4076c184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4076c184",
  null
  
)

export default component.exports